import {createSelector} from 'reselect';

import {type DesignerStores} from '@packages/systems/designer/flux';
import {type ExpressionElement} from '@packages/systems/wfdl-ast';
import {maybe} from '@packages/utilities/fp/option';
import {identity} from '@packages/utilities/fp/utils';

export const getClippedElement: (
  arg1: DesignerStores
) => ExpressionElement | null = createSelector(
  (state: DesignerStores) => state.ClipboardStore,
  (clipboardState) => {
    return maybe<ExpressionElement | null>(null)(identity<ExpressionElement>)(
      clipboardState.map((clipboard) => clipboard.clippedElement)
    );
  }
);
